'use client';

import {useEffect} from "react";
import PropTypes from "prop-types";
import {useSnackbar} from "notistack";
import {useRouter} from "next/navigation";

import LoadingScreen from 'src/components/loading-screen/loading-screen';

export default function SnackbarRedirect({message, options = null, redirectUrl}) {
  const {enqueueSnackbar } = useSnackbar();
  const router = useRouter();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      enqueueSnackbar(message, options);
      router.push(redirectUrl);
    }
  }, [enqueueSnackbar, message, options, redirectUrl, router]);

  return <LoadingScreen />;
}

SnackbarRedirect.propTypes = {
  message: PropTypes.string,
  redirectUrl: PropTypes.string,
  options: PropTypes.object
}
